import DocumentRequestsAPI from './documentRequests';

// Ticket-scoped document-request checklist singleton.
// Owner id is the ticket display_id (the URL identifier for nested ticket routes).
export default new DocumentRequestsAPI('tickets');
